import {AttributeCriteriaDto} from './';
import {UomCriteriaDto} from './uom-criteria.dto';

export class CriteriaDto {
  attributeAnd: AttributeCriteriaDto[] = [];
  uomAnd?: UomCriteriaDto[] = [];
}
